/*
 * Accordion buy box handler.
 * Loaded only when section.settings.buybox_style == 'accordion'.
 *
 * Behavior:
 *  - Single-open: clicking any plan header expands it + selects it + collapses others.
 *  - Hidden input[name="selling_plan"] updates to the active plan's ID.
 *  - Anchor plan: clicking selects it but doesn't expand (no body).
 *  - Respects prefers-reduced-motion.
 *
 * A11y model:
 *  - Discounted plans are accordion triggers — JS sets aria-expanded only.
 *  - Anchor plan is a pure toggle button (no body) — JS sets aria-pressed only.
 *  - Don't mix the two attributes on the same element.
 */
(function () {
  function initOne(root) {
    if (!root || root.dataset.bbInit === 'true') return;
    root.dataset.bbInit = 'true';

    var planInput = root.querySelector('[data-selling-plan-input]');
    var plans = root.querySelectorAll('[data-bb-plan]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var sectionRoot = root.closest('[id^="product-main-"]');
    var sticky = sectionRoot ? sectionRoot.querySelector('[data-pdp-sticky]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var stickyPlanName = sticky ? sticky.querySelector('[data-sticky-plan-name]') : null;
    var ctaPrice = root.querySelector('[data-cta-price]');

    function syncSticky(plan) {
      if (!plan) return;
      if (stickyPrice) stickyPrice.textContent = plan.dataset.priceTotal || plan.dataset.price || '';
      if (stickyPlanName) stickyPlanName.textContent = plan.dataset.planName || '';
    }

    function syncCta(plan) {
      if (!plan || !ctaPrice) return;
      ctaPrice.textContent = plan.dataset.priceTotal || '';
    }

    function setOpenState(plan, open) {
      var body = plan.querySelector('[data-bb-body]');
      var toggle = plan.querySelector('[data-bb-toggle]');
      var isAnchor = plan.hasAttribute('data-bb-anchor');

      plan.classList.toggle('is-open', open && !isAnchor);
      plan.classList.toggle('active', open);
      if (toggle) {
        if (isAnchor) {
          /* Anchor: pure toggle button, no body → aria-pressed */
          toggle.setAttribute('aria-pressed', open ? 'true' : 'false');
        } else {
          /* Discounted plan: accordion trigger → aria-expanded */
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }
      if (!body) return; /* anchor */

      if (open) {
        body.hidden = false;
        if (reduceMotion) {
          body.style.maxHeight = 'none';
          body.style.opacity = '1';
        } else {
          /* Set explicit max-height to enable transition */
          body.style.maxHeight = body.scrollHeight + 'px';
          body.style.opacity = '1';
        }
      } else {
        if (reduceMotion) {
          body.style.maxHeight = '0';
          body.style.opacity = '0';
          body.hidden = true;
        } else {
          /* From measured height → 0, then hide after transition */
          body.style.maxHeight = body.scrollHeight + 'px';
          /* Force reflow so the next assignment animates */
          void body.offsetHeight;
          body.style.maxHeight = '0';
          body.style.opacity = '0';
          window.setTimeout(function () {
            if (!plan.classList.contains('is-open')) body.hidden = true;
          }, 220);
        }
      }
    }

    function select(targetPlan) {
      var targetId = targetPlan.dataset.sellingPlan || '';
      plans.forEach(function (p) {
        setOpenState(p, p === targetPlan);
      });
      if (planInput) {
        planInput.value = targetId;
        /* Trigger change event so anything listening (sticky bar, analytics) can react */
        planInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncSticky(targetPlan);
      syncCta(targetPlan);
    }

    /* Initial state: one plan starts .is-open from Liquid. Ensure its body is fully expanded. */
    var initiallyOpen = null;
    plans.forEach(function (p) {
      var body = p.querySelector('[data-bb-body]');
      if (p.classList.contains('is-open') && body) {
        body.hidden = false;
        body.style.maxHeight = 'none';
        body.style.opacity = '1';
        initiallyOpen = p;
      }
    });
    /* If no discounted plan is open (e.g. all anchors), fall back to the active anchor */
    if (!initiallyOpen) {
      initiallyOpen = root.querySelector('[data-bb-plan].active');
    }
    syncSticky(initiallyOpen);
    syncCta(initiallyOpen);

    plans.forEach(function (plan) {
      var toggle = plan.querySelector('[data-bb-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        /* No-op if clicking the already-active plan's header */
        if (plan.classList.contains('active')) return;
        select(plan);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.bb-accordion').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', initAll);
})();
